export const getLocalStorageItem = (name: string): string => {
  // eslint-disable-next-line no-useless-escape
  return (localStorage.getItem(name) || "").replace(/\"/g, "");
};
export const setLocalStorageItem = (name, value): void => {
  localStorage.setItem(name, value);
};
export const removeLocalStorageItem = (name): void => {
  localStorage.removeItem(name);
};
